import { render, staticRenderFns } from "./SysStatusProduto.vue?vue&type=template&id=a2cd5444&scoped=true"
import script from "./SysStatusProduto.vue?vue&type=script&lang=js"
export * from "./SysStatusProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cd5444",
  null
  
)

export default component.exports